import React, { useState } from "react"
import swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import ls from 'localstorage-slim';
import { toast } from "react-toastify"

import Container from "../../../components/UI/Container/Container"
import PageTitle from "../../../components/UI/PageTitle/PageTitle"
import Upload from "../../Upload/Upload"
import PleaseWaitModal from "../../BarCodes/modals/PleaseWaitModal"
import { executeAsyncWithModal } from "../../../helpers/modal"
import { loadFile } from "../../../helpers/loadFile"
import { getHeaders } from "../../../helpers/getHeaders"
import axios from "../../../axios-instance";
import { getCustomURLs } from "../../../helpers/getCustomURLs"
import Icon from "../../../components/UI/Icon/Icon"

import styles from './HoldedSeatsManagment.module.sass';

const MANAGE_SEATS_ACTIONS = [
    {
        value: "/MembershipManagment/add-holded-seats",
        label: "Add seats from the file to existing seats",
        fileResult: true,
    },
];

const MySwal = withReactContent(swal);

export const HoldedSeatsManagment = () => {
    const [state, setStateInternal] = useState({
        file: [],
        selectedEventActionPath: MANAGE_SEATS_ACTIONS[0].value,
    });
    const setState = (p) => setStateInternal(v => { return { ...v, ...p } });

    const removeFile = () => {
        setState({ file: [] })
    }

    const closeFileHandler = () => {
        setState({ selectedEventActionPath: MANAGE_SEATS_ACTIONS[0].value });
    };

    const checkIsDisabled = () => {
        const { file } = state;

        return !file || !file.length;
    };

    const downloadDataAsFile = (data, name) => {
        if (data) {
            loadFile(data, name);

            toast.success("File downloaded successfully");
        } else {
            toast.error("Failed to retrieve data");
        }
    };

    const downloadHoldedSeatsReportHandler = async () => {
      try {

        const user = ls.get("user");

        const request = () =>
          axios.get(`/MembershipManagment/holded-seats-report`, {
            headers: getHeaders(user.token),
          });

        const { data } = await executeAsyncWithModal(
          request,
          <PleaseWaitModal message="Downloading file…" />
        );

        downloadDataAsFile(data, `Holded Seats Report.csv`);
      } catch (e) {
        toast.error("File was not downloaded");
        console.log(e);
      }
    };

    const uploadFile = async (eventActionPath, body = null) => {
        let result = {
            data: null,
            isSuccess: false,
        };

        if (!navigator.onLine) {
            return result;
        }

        try {

            const user = ls.get('user');
            const url = `${eventActionPath}/`;

            const { data } = await axios.post(url, body, {
                headers: getHeaders(user.token),
            });

            result = {
                data: data,
                isSuccess: true,
            };
        } catch (e) {
            console.log(e);
        }

        return result;
    };

    const onButtonEnable = (file) => {
        setState({
            file,
        });
    };

    const handleSubmit = async () => {
        const { file } = state;

        const body = new FormData();
        body.append("file", file[0]);
        const fileAsResult = MANAGE_SEATS_ACTIONS.find(a => a.value === state.selectedEventActionPath).fileResult;

        const { isSuccess, data } = await executeAsyncWithModal(
            () => uploadFile(state.selectedEventActionPath, body),
            <PleaseWaitModal message={fileAsResult ? "Downloading file…" : "Processing..."} />
        );

        if (fileAsResult) {
            if (isSuccess) {
                downloadDataAsFile(data, "NotProcessedSeats.csv");
            } else {
                toast.error("File was not downloaded");
            }
        }
        else {
            if (isSuccess) {
                toast.success("Completed");
            } else {
                toast.error("Something went wrong");
            }
        }
    };

    const restoreSeats = async () => {
        const user = ls.get('user');


        try {
            const { data } = await axios.post('/MembershipManagment/restore-holded-seats',
                null,
                {
                    headers: getHeaders(user.token),
                }
            )

            toast.success("Completed");
        } catch (e) {
            toast.error("Something went wrong");
        }


    };

    const showRestoreSeatsModal = () => {
      MySwal.fire({
        title: 'Are you sure you want to reset holded seats?',
        showCancelButton: true,
        cancelButtonText: 'Cancel',
        confirmButtonText: 'Reset',
        reverseButtons: true,
        customClass: 'confirm-lost-ticket-modal',
      }).then((result) => {
        if (result.value) {
          restoreSeats();
        }
      });
    };

    const { SERVER_URL } = getCustomURLs();

    return <Container className="membership-managment">
        <PageTitle>Holded Seats</PageTitle>

        <div className={styles['container']}>

            <div className="download-actions-container">
              <div
                  className="seats__download download-action"
              >
                  <Icon name="excel" />
                  <form
                      action={SERVER_URL + "/FilesExamples/HoldedSeatsTemplate.csv"}
                      method="GET">
                      <button>Download template</button>
                  </form>
              </div>

              <div
                  className="seats__download download-action"
              >
                  <Icon name="excel" />
                  <button onClick={downloadHoldedSeatsReportHandler}>Download holded seats report</button>
              </div>
            </div>

            <div className="seats__upload">
                <div className="seats__choose-file">
                    <p className={styles['upload-description']} >Choose the file ( .csv)</p>

                    <Upload
                        onClose={closeFileHandler}
                        onButtonEnable={onButtonEnable}
                        removeFile={removeFile}
                    />            </div>
            </div>

            <div className={styles['footer']}>
                <button
                    type="button"
                    onClick={showRestoreSeatsModal}
                    className="seats__submit btn-red-outline">
                    Reset holded seats
                </button>

                <button
                    type="button"
                    disabled={checkIsDisabled()}
                    onClick={handleSubmit}
                    className="seats__submit btn-primary">
                    Send
                </button>
            </div>
        </div>

    </Container>
}